const state = {
  serviceHeader: {
    title: [
      "<span class='yellowColor'> خزمەتگوزارییەکانمان </span>",
      "<span class='yellowColor'>خدماتنا</span>",
      "Our <span class='yellowColor'>Services</span>"
    ],
    body: [
      "کۆمپانیاکەمان ئامانجی گەشەپێدان و باشترکردنی کاری کڕیارەکانمانە لەڕێی پێشکەشکردنی باشترین خزمەتگوزاری و بەرهەمەوە",
      "تتمثل مهمة شركتنا في تعزيز العمليات التجارية لعملائنا من خلال تطوير وتنفيذ أفضل منتجات وخدمات تكنولوجيا المعلومات",
      "Our company mission is to enhance the business operation of our clients by developing and implementing best IT products and services"
    ]
  },
  services: [
    {
      id: 1,
      title: ["وێبسایت", " موقع الكتروني", "Website"],
      body: [
        "دیزاین و گەشەێدانی وێبسایت و وێب ئەپڵیکەیشن بە بەکارهێنانی نوێترین تەکنەلۆجیا",
        "تصميم وتطوير موقع الويب وتطبيق الويب باستخدام أحدث التقنيات ",
        "Design and develop website and web application by using newest technologies"
      ],
      link: "#",
      image: "web.png"
    },
    {
      id: 2,
      title: [
        "مۆبایل ئەپڵیکەیشن",
        "تطبيق الهاتف المحمول",
        "Mobile Application"
      ],
      body: [
        "گەشەپێدانی مۆبایل ئەپڵیکەیشن بۆ هەردوو سیستەمی  ئای ئۆ ئێس و ئەندرۆید",
        "تطوير تطبيقات الهاتف لكل من نظام التشغيل IOS و Android",
        "Developing mobile application for both IOS and Android Operating system"
      ],
      link: "#",
      image: "mobile.png"
    },
    {
      id: 3,
      title: ["داتابەیس", "قاعدة البيانات", "Database"],
      body: [
        "گەشپێدانی داتابەیس بەشێوازی ئۆنڵاین و ئۆفڵاین بۆ هەر مەبەستێک و شوێنێک",
        "تطوير تطبيق قاعدة بيانات وضع متصل وغير متصل لعملائنا ولأي غرض",
        "Developing offline and online mode database application for our clients and for any purpose"
      ],
      link: "#",
      image: "database.png"
    },
    {
      id: 4,
      title: ["دۆمەین", "مجال", "Domain"],
      body: [
        "کڕین و حیجزکردنی هەموو جۆرە دۆمەینێک",
        "التسجيل لأي اسم المجال",
        "Registration for any domain name"
      ],
      link: "#",
      image: "domain.png"
    },
    {
      id: 5,
      title: ["هۆستین", "خدمات الاستضافة", "Hosting"],
      body: [
        "بڵاوکردنەوەی هەموو جۆرە وێبسایت و مۆبایل ئەپڵیکەیشنێک",
        "نشر أي موقع ويب وتطبيق جوال",
        "Publishing any website and mobile application"
      ],
      link: "#",
      image: "hosting.png"
    },
    {
      id: 6,
      title: ["نێتۆڕک", "شبكة الاتصال", "Network"],
      body: [
        "کۆمەڵێک خزمەتگوزاری نێتۆڕک پێشکەش دەکەین وەک دیزاین، دروستکردن، بەڕێوەبردن وە پاڵپشتی کردنی هەموو جۆرە نێتۆڕکێک",
        "نحن نقدم العديد من خدمات الشبكة مثل التصميم والتنفيذ والإشراف ودعم أي نظام شبكة",
        "We provide many network services like Design, implementation, supervision, support any network system"
      ],
      link: "#",
      image: "network.png"
    },
    {
      id: 7,
      title: [
        "بەڕێوەبردنی سۆشیاڵ میدیا",
        "إدارة وسائل التواصل الاجتماعي",
        "Social media managment"
      ],
      body: [
        "بەڕێوەبردنی کارو باری ڕیکلامی و بەبازارکردنی بەرهەمی کۆمپانیا و شوێنە بازرگانیەکان لەسەر تۆڕە کۆمەڵایەتییەکان",
        "إدارة وتسويق للشركات والمؤسسات الصناعية على منصات التواصل الاجتماعي",
        "Managing and marketing for companies and industrial organizations on social media platforms"
      ],
      link: "#",
      image: "socialmedia.png"
    }
  ]
};

const getters = {
  listOfServices: state => state.services,
  serviceHeader: state => state.serviceHeader
};

const actions = {};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
